<template>
    <div class="">
        <div class="row">
            <div style="position: relative; height: 600px;">
                <div class="carousel fade-carousel slide" data-interval="4000" id="bs-carousel-review">
                    <div class="overlay"></div>
                    <ol class="carousel-indicators">
                        <li data-target="#bs-carousel-review" v-for="screenshot in screenshots" :class="{ 'active': screenshot.index === 0 }" :key="screenshot.index" :data-slide-to="screenshot.index"></li>
                    </ol>
                    <div class="carousel-inner">
                        <div class="item slides" v-for="screenshot in screenshots" :key="screenshot.index" :class="{ 'active': screenshot.index === 0 }">
                            <div class="slide-container" :class="`slide-${(screenshot.index + 1)}`"></div>
                            <div class="ol-featured_background" :style="{ backgroundImage: screenshot.backgroundImage }"></div>
                        </div>
                    </div>
                </div>
                <div class="hero review">
                    <hgroup>
                        <h1>{{ name }}</h1>
                        <div v-if="reviewer" class="ol-featured_content-type">reviewed by {{ reviewer }}</div>
                        <div v-else class="ol-featured_content-type">review pending</div>
                        <div class="ol-featured_divider"></div>
                        <div v-if="score" class="ol-featured_sub-header release-date"><i class="fa fa-star-o"></i>{{ score }} out of 10 stars</div>
                        <div class="ol-featured_sub-header release-date"><i class="fa fa-gamepad"></i>{{ gameTypes | arrayToString }}</div>
                        <div v-if="mods" class="ol-featured_sub-header release-date"><i class="fa fa-pencil"></i>Has mods</div>
                        <div v-else class="ol-featured_sub-header release-date"><i class="fa fa-pencil"></i>No mods</div>
                        <div class="ol-featured_sub-header release-date"><i class="fa fa-calendar-o"></i>{{ releaseDate | date }}</div>
                        <div class="ol-featured_sub-header author"><i class="fa fa-user"></i>{{ author }}</div>
                        <div class="ol-featured_divider"></div>
                        <div class="ol-featured_description">{{ review }}</div>
                    </hgroup>
                    <div class="ol-featured_actions">
                        <a class="ol-featured_button" :href="`${siteUrl}/maps/${filename}`">Download Now</a>
                        <router-link class="ol-featured_button" v-if="canReview" :to="`/review/${id}/edit`">Edit Review</router-link>
                    </div>
                </div>
            </div>
        </div>
        <br/>
        <div class="container">
            <div class="row" v-for="row in screenshot_chunks">
                <div v-for="screenshot in row" :key="screenshot.index" class="col-md-4">
                    <div class="map-card">
                        <a href="#" @click.prevent="showScreenshot(screenshot)">
                            <img :src="`${screenshot.src}`" />
                            <div class="map-card__mask"></div>
                        </a>
                    </div>
                </div>
            </div>
            <div class="row">
                <br/>
                <div v-if="youtube" class="col-md-8">
                    <iframe width="560" height="315" :src="youtube" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
                </div>
                <div v-if="games.length" class="col-md-4">
                    <h3>Recent Games</h3>
                    <table class="table table-condensed">
                        <thead>
                            <th width="20%">Host</th>
                            <th width="20%">Type</th>
                            <th width="60%">Started On</th>
                        </thead>
                        <tbody>
                            <tr v-for="game in games" :key="game._id">
                                <td>{{ game.host }}</td>
                                <td>{{ game.gameType || 'Unknown' }}</td>
                                <td>{{ game.createdOn | dateTime }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="readme" class="row">
                <h3>Readme File</h3>
                <div class="bs-callout bs-callout-default left" v-html="readme"></div>
            </div>
        </div>
        <div class="modal fade" id="imagemodal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
            <div class="modal-dialog" style="width: 800px">
                <div class="modal-content">
                    <div class="modal-body">
                        <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                        <img class="imagepreview" :src="previewScreen" style="width: 100%;" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { api } from '../framework/api';
import { copyCommonProperties } from '../framework/utils'
import { settings } from '../framework/settings';
import _ from 'lodash'
    export default {
        props: { _id: String },
        computed: {
            canReview() {
                return this.sharedState.canReview;
            },
            youtube() {
                var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                if(this.links && this.links.length) {
                    let yt = this.links[0].youtube;
                    var match = yt.match(regExp);
                    if(match && match[2].length == 11) {
                        return `//www.youtube.com/embed/${match[2]}`;
                    }
                    else {
                        return null;
                    }
                }

                return null;
            },
            screenshot_chunks() {
                return _.chunk(this.screenshots, 3);
            }
        },
        data() {
            return {
                siteUrl: settings.siteUrl,
                id: this._id,
                games: [],
                previewScreen: null,
                screenshots: [],
                gameTypes: [],
                status: null,
                name: null,
                author: null,
                filename: null,
                filesize: null,
                links: [],
                externalReviews: [],
                mods: null,
                reviewer: null,
                review: null,
                score: null,
                releaseDate: null,
                createdOn: null,
                readme: null
            }
        },
        async created() {
            this.id = await this.getMapId();
            let calls = [
                api.get(`reviews/${this.id}`),
                api.get(`reviews/${this.id}/readme`)
            ];
            let [review, readme] = await Promise.all(calls);
            copyCommonProperties(review.data, this.$data);
            var i = 0;
            this.screenshots = this.screenshots.map(ss => {
                let src = `${settings.siteUrl}/screens/${ss}`;
                let s = {
                    src,
                    index: i++,
                    backgroundImage: `url('${src}')`
                }
                return s;
            });
            if(this.screenshots.length) {
                $("#bs-carousel-review").carousel();
            }
            this.readme = readme.data;
        },
        methods: {
            showScreenshot(screenshot) {
                this.previewScreen = screenshot.src;
                $("#imagemodal").modal('show');
            },
            async getMapId() {
                if(isNaN(this._id)) return this._id;
                // for backward compatability with old urls
                let result = await api.get(`reviewId/${this._id}`);
                return result.data._id;
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Review.vue